// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"764":"css/app.6800","9888":"css/admin-app.6800"}[chunkId] + ".css";
};